/**
 * @preserve
 * jQuery Scroll Toggle - v1.0.1
 * Copyright (c) 2016 Karsten Müller
 */

(function ( $ ){

	var defaults = {

		position: -1,

		offset: 0,

		callbackIn: function(){
			console.log("Element is in");
		},

		callbackOut: function(){
			console.log("Element is out");
		}

	};

	$.fn.scrollToggle = function(options){

		var options = options || {};

		return this.each(function(){

			var container = $(this);


				/* Einstellungen über Data-Attribute */

			var data = {
				position: container.data("scroll-toggle-position"),
				offset: container.data("scroll-toggle-offset")
			}


				/* Einstellungen vereinen */

			var settings = $.extend({}, defaults, options, data);


				/* Trigger wurde nicht festgelegt */

			if (settings.position === -1){
				settings.position = container.offset().top;
			}


			new ScrollToggle(container, settings);

		});


	};

	var ScrollToggle = function(container, settings){

		var self = this;

		this.toggle = false;
		this.is_toggled = false;

		this.container = container;
		this.settings = settings;

		this.callbackIn = settings.callbackIn;
		this.callbackOut = settings.callbackOut;

		$(window).on("resize", function(event){
			self.settings.position = self.container.offset().top;
		}, 250);

		$(window).scroll(

			function (event){

				var top = $(window).scrollTop();

				var toggle = ($(window).scrollTop() >= Math.floor(settings.position - settings.offset));

				if (toggle !== self.is_toggled){

					if (toggle) {
						self.callbackIn(container);
					}
					else {
						self.callbackOut(container);
					}
				}

				self.is_toggled = toggle;

			}

		);

		$(window).trigger("scroll");


	}


}( jQuery ));

